module.exports = __webpack_public_path__ + "img/card_choose_2.9ad6bc7a.png";